export const buildInformation = {
  buildGitCommitHash: "89e0f0c615577b2c5bed1f390ae1a9207292ad03",
  buildTimestamp: 1628706784081,
  buildTime: "2021-8-11 18:33:04"
};
